import { ChatBubbleComponent } from './components/chat-bubble/chat-bubble.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { routes } from './chat.routes';
import { UIRouterModule } from '@uirouter/angular';
import { TemplateEditorModule } from '../template-editor/template-editor.module';
import { PresentationsModule } from '../presentations/presentations.module';
import { UserStateService } from '../auth/services/user-state.service';

@NgModule({
  declarations: [
    ChatHistoryComponent,
    ChatBubbleComponent,
    ChatComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild(routes),
    TemplateEditorModule,
    PresentationsModule
  ],
  providers: [
    UserStateService
  ],
})
export class ChatModule { }
